function routeMap(container, lat, lon) {
    if ( $('#'+container).length ) {
        ymaps.ready(function () {
            var map = new ymaps.Map(container, {
                    center: [lat, lon],
                    zoom: 13,
                    controls: []
                }),
                placemark = new ymaps.Placemark(map.getCenter(), {
                    hintContent: 'Москва, ул. Профсоюзная, д. 64, корп. 2',
                    balloonContent: 'Москва, ул. Профсоюзная, д. 64, корп. 2'
                }, {
                    iconLayout: 'default#image',
                    iconImageHref: 'assets/images/svg_icons/map-marker.svg',
                    iconImageSize: [31, 45],
                    iconImageOffset: [-15, -40]
                });

            map.geoObjects.add(placemark);
        });
    }
}